import { blankDataModel } from 'app/constants/conversation-data-models';
import { DEFAULT_GROQ_CHAT_MODEL } from 'app/constants/ai-model-constants';

export interface AiResponse {
  dataModel: any;
  responseText: string;
  intent: any;
}

export function buildQueryPayload(
  query: string,
  conversation: any[],
  currentDataModel: any,
  user: any
) {
  const userData = {
    userCurrentLocation: user.currentLocation,
    preferences: user.preferences,
    memberships: user.memberships,
  };
  const dataModel = conversation.length > 1 ? currentDataModel : blankDataModel;
  const history = conversation
    .filter(entry => entry.agent !== '')
    .slice(-30)
    .map(({ dataModel, ...rest }) => rest);
  return {
    userQuery: query,
    history,
    model: DEFAULT_GROQ_CHAT_MODEL,
    dataModel,
    userData,
  };
}

export function parseAiResponse(responseString: string): AiResponse {
  const cleanedResponse = responseString
    .replace(/<think>[\s\S]*?<\/think>/gi, '')
    .trim();

  const jsonString = cleanedResponse
    .replace(/```json\n?/, '')
    .replace(/\n?```/, '')
    .trim();

  return JSON.parse(jsonString);
}
